import { __assign, __rest } from "tslib";
import React from 'react';
import { colors } from '@keen.io/colors';
import { LegendCard } from './card.styles';
var Card = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? colors.white['500'] : _b, _c = _a.hasShadow, hasShadow = _c === void 0 ? true : _c, _d = _a.fullDimension, fullDimension = _d === void 0 ? false : _d, props = __rest(_a, ["backgroundColor", "hasShadow", "fullDimension"]);
    return (React.createElement(LegendCard, __assign({ fullDimension: fullDimension, backgroundColor: backgroundColor, hasShadow: hasShadow }, props)));
};
export default Card;
